<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useSlots } from 'vue';

/*==================================================================*/
/*================ UTILS IMPORTS ===================================*/
/*==================================================================*/

import UtilLabel from '@/utils/UtilLabel';
import UtilObject from '@/utils/UtilObject';
import ListaAnexoBase from '@/components/v2/base/ListaAnexoBase/ListaAnexoBase.vue';
import CampoCheckboxBase from '@/components/v2/base/CampoCheckboxBase/CampoCheckboxBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    headers: {
        type: Array,
        default: () => []
    },
    dado: {
        type: Object,
        default: () => ({})
    },
    disabled: {
        type: Boolean,
        default: false
    },
    selecao: {
        type: String,
        default: 'nenhum'
    },
    selecionado: {
        type: Boolean,
        default: false
    }
});

const emits = defineEmits([
    'update:selecionado',
]);

const slots = useSlots();

/*==================================================================*/
/*================== FORMATAÇÃO DE CÉLULAS =========================*/
/*==================================================================*/

const formataValorDaCelula = (header = {}) => {

    const type = header?.type || 'string';
    
    const valor = UtilObject.resolveByPath(props.dado, header?.value || '');

    if(valor === null || valor === undefined || valor === ''){
        return '-';
    }

    if(type === 'date'){
        return UtilLabel.toDate(valor);
    }

    if(type === 'money'){
        return UtilLabel.toMoney(valor);
    }

    if(type === 'boolean'){
        return UtilLabel.toBoolean(valor);
    }

    if(type === 'number'){
        return UtilLabel.toNumber(valor);
    }

    if(type === 'km'){
        return UtilLabel.toKM(valor);
    }

    if(type === 'percentage'){
        return UtilLabel.toPercentage(valor);
    }

    return valor;

};

</script>

<template>

    <div class="c-tabela__row">

        <div class="c-tabela__cell"
            v-for="header in props.headers"
            :key="header.value"
        >

            <div class="c-tabela__cell-content">

                <template v-if="header.value === 'botoes'">

                    <template v-if="slots['linha-botoes']">

                        <slot
                            name="linha-botoes"
                            :dado="props.dado"
                            :disabled="props.disabled"
                        ></slot>

                    </template>

                </template>

                <template v-else-if="header.value === 'selecao'">

                    <CampoCheckboxBase
                        v-if="props.selecao !== 'nenhum'"
                        :value="props.selecionado"
                        :disabled="props.disabled"
                        @change="emits('update:selecionado', $event)"
                    ></CampoCheckboxBase>

                </template>

                <template v-else-if="header.value === 'selecao'">

                    <CampoCheckboxBase
                        v-if="props.selecao !== 'nenhum'"
                        :value="props.selecionado"
                        :disabled="props.disabled"
                        @change="emits('update:selecionado', $event)"
                    ></CampoCheckboxBase>

                </template>

                <template v-else-if="header.value !== 'espaco'">

                    <template v-if="slots[`linha-item.${header.value}`]">

                        <slot
                            :name="`linha-item.${header.value}`"
                            :dado="props.dado"
                            :disabled="props.disabled"
                        ></slot>

                    </template>

                    <template v-else>

                        <ListaAnexoBase
                            v-if="header?.type === 'anexo'"
                            :value="UtilObject.resolveByPath(props.dado, header?.value || '')"
                        ></ListaAnexoBase>

                        <template v-else>
                            {{ formataValorDaCelula(header) }}
                        </template>

                    </template>

                </template>

            </div>

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*================== Linha da Tabela ===============================*/
/*==================================================================*/

.c-tabela__row {
    display: contents;
}

/*==================================================================*/
/*================== Célula da Linha ===============================*/
/*==================================================================*/

.c-tabela__cell {
    padding: 12px 16px;
    align-content: center;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-tabela__cell-content {
    display: flex;
    align-items: center;
    gap: 4px;
}

</style>
